import axios from "axios"
import { BACKEND } from "../../config/configEnvs"

export const CrearIncidencia = async ({
  fecha = new Date(), 
  titulo = "Incidencia creada automáticamente", 
  comentario = "Incidencia creada automáticamente por sistema MC",
  trabajador, 
  descuento = 0,
}) => {
  try {
    await axios.post(`${BACKEND}/api/incidencias`, {
      fecha: fecha,
      titulo: titulo,
      comentario: comentario,
      trabajador: trabajador,
      descuento: descuento,
      descuentoPorDefinir: descuento === 0 ? true : false,
      gravedad: "Leve",
      autor: "Sistema MC",
      month: fecha.getMonth() + 1,
      year: fecha.getFullYear()
    })
  } catch (e) {
    return false
  }
}